import React from 'react';
import { Discount } from '../Discount';
import { RenderPayments } from '../Payments';
import { toRound } from '../../../helpers/Format';
import { T } from '../../../helpers/i18n';
import { Texto } from '../Texto';
import { Align } from '../../../modules/ReceiptLayouts/Model';
import { BlockBookingFee } from './BlockBookingFee';
export var BlockPayments = function (_a) {
    var item = _a.item;
    var canceled = !!item.daterefund;
    var taxes = {};
    // OJO CON instanceof CUANDO SE PASA POR history.location.state, al pulsar en el item se envía el tipo pero en recarga lo pierde
    if (!item.packet_id && item.extraLines) {
        // añado taxes de extras
        // @ts-ignore
        taxes = getTaxesFromExtraLines(item.extraLines);
    }
    // console.log('!(item as PacketTicket).packet_id: ', !(item as PacketTicket).packet_id)
    // añado tax del servicio
    if (!taxes[item.taxName]) {
        taxes[item.taxName] = item.taxAmount;
    }
    else {
        taxes[item.taxName] += item.taxAmount;
    }
    return (React.createElement("div", { style: {
            width: '90%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
        } },
        item.discount > 0 &&
            React.createElement(Discount, { item: item }),
        item.discountReason &&
            React.createElement(Texto, { texto: "".concat(T('discountreasons'), ": ").concat(item.discountReason), align: Align.Right }),
        React.createElement(RenderPayments, { item: item }),
        React.createElement(BlockBookingFee, { item: item }),
        React.createElement("p", { style: { textDecoration: canceled ? 'line-through' : 'initial', margin: '0', padding: 0, fontWeight: 'bold', textAlign: 'end', } }, "Total  ".concat(toRound(item.total)).concat(item.money)),
        item.totalDue > 0 && React.createElement("p", { style: {
                textDecoration: canceled ? 'line-through' : 'initial',
                margin: '0', padding: 0, fontWeight: 'bold', textAlign: 'end',
                backgroundColor: item.totalDue > 0 ? 'red' : undefined,
                color: item.totalDue > 0 ? 'white' : undefined
            } }, "Pendiente pago  ".concat(toRound(item.totalDue)).concat(item.money)),
        React.createElement("p", { style: { margin: '0', padding: 0, fontWeight: 'bold', textAlign: 'end' } },
            canceled ? '' : '\u00A0',
            canceled ? T('canceled') : ''),
        taxes && Object.entries(taxes).map(function (tax, index, array) { return (React.createElement("p", { key: tax[0], style: { textAlign: 'end', width: '100%', marginRight: '30px', marginBottom: index !== array.length - 1 ? 0 : undefined, marginTop: 0 } }, "Incluido ".concat(tax[0]))); }),
        React.createElement("p", { style: { textAlign: 'end', width: '100%', marginRight: '30px' } }, "".concat(T('tin'), ": ").concat(item.tin))));
};
export var getTaxesFromExtraLines = function (extraLines) {
    if (!extraLines) {
        return {};
    }
    var taxes = {};
    for (var i = 0; i < extraLines.length; i++) {
        if (taxes[extraLines[i].taxName]) {
            taxes[extraLines[i].taxName] += extraLines[i].taxAmount;
        }
        else {
            taxes[extraLines[i].taxName] = extraLines[i].taxAmount;
        }
    }
    return taxes;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockPayments.tsx
// module id = 255
// module chunks = 0